import { useEffect, useState } from "react";
import axios from "../../utils/axiosInstance";

const Customer = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [topN, setTopN] = useState(10);
  const [inactiveDays, setInactiveDays] = useState(90);
  const [error, setError] = useState(null);

  const fetchReport = async () => {
    try {
      setLoading(true);
      setError(null);
      const params = {
        topN,
        inactiveDays,
      };
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;
      // اگر لازم است می‌توان paidStatuses هم فرستاد:
      // params.paidStatuses = "Paid,Delivered";

      const res = await axios.get("/reports/customers", { params });
      setData(res.data);
    } catch (err) {
      console.error("Error loading customer report:", err);
      setError(err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // بار اول بدون فیلترها لود کن
    fetchReport();
  }, []);

  return (
    <div className="container my-4">
      <h3>Customer Reports</h3>

      <div className="card mb-3 p-3">
        <div className="row g-2">
          <div className="col-12 col-md-3">
            <label className="form-label">From</label>
            <input
              type="date"
              className="form-control"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>
          <div className="col-12 col-md-3">
            <label className="form-label">To</label>
            <input
              type="date"
              className="form-control"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
          <div className="col-6 col-md-2">
            <label className="form-label">Top N</label>
            <input
              type="number"
              className="form-control"
              value={topN}
              min={1}
              onChange={(e) => setTopN(Number(e.target.value))}
            />
          </div>
          <div className="col-6 col-md-2">
            <label className="form-label">Inactive days</label>
            <input
              type="number"
              className="form-control"
              value={inactiveDays}
              min={1}
              onChange={(e) => setInactiveDays(Number(e.target.value))}
            />
          </div>
          <div className="col-12 col-md-2 d-flex align-items-end">
            <button
              className="btn btn-primary w-100"
              onClick={fetchReport}
              disabled={loading}
            >
              {loading ? "Loading..." : "Apply"}
            </button>
          </div>
        </div>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      {!data ? (
        <div>Loading...</div>
      ) : (
        <>
          <div className="row g-3 mb-3">
            <div className="col-6 col-md-3">
              <div className="card p-3 text-center">
                <div className="text-muted">Active Customers</div>
                <h4>{data.activeCount}</h4>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="card p-3 text-center">
                <div className="text-muted">New Customers</div>
                <h4>{data.newCount}</h4>
              </div>
            </div>

            <div className="col-6 col-md-3">
              <div className="card p-3 text-center">
                <div className="text-muted">Inactive Customers</div>
                <h4>{data.inactiveCount}</h4>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="card p-3 text-center">
                <div className="text-muted">Top buyers (N={topN})</div>
                <h4>{(data.topBuyers || []).length}</h4>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-lg-6 mb-3">
              <div className="card">
                <div className="card-header">Top Buyers</div>
                <div className="card-body p-0">
                  <table className="table mb-0">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Total Spent</th>
                        <th>Orders</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(data.topBuyers || []).map((u, i) => (
                        <tr key={u.userId || i}>
                          <td>{i + 1}</td>
                          <td>{u.name || "-"}</td>
                          <td>{u.email || "-"}</td>
                          <td>{Number(u.totalSpent || 0).toLocaleString()}</td>
                          <td>{u.ordersCount}</td>
                        </tr>
                      ))}
                      {(data.topBuyers || []).length === 0 && (
                        <tr>
                          <td colSpan={5} className="text-center">
                            No data
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-6 mb-3">
              <div className="card">
                <div className="card-header">Inactive Customers (sample)</div>
                <div className="card-body p-0">
                  <table className="table mb-0">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Last Activity / Created</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(data.inactiveCustomers || [])
                        .slice(0, 50)
                        .map((u, i) => (
                          <tr key={u.userId || i}>
                            <td>{i + 1}</td>
                            <td>{u.name || "-"}</td>
                            <td>{u.email || "-"}</td>
                            <td>
                              {u.lastOrder
                                ? new Date(u.lastOrder).toLocaleDateString()
                                : "-"}
                            </td>
                          </tr>
                        ))}
                      {(data.inactiveCustomers || []).length === 0 && (
                        <tr>
                          <td colSpan={4} className="text-center">
                            No data
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Customer;
